// TopShelf Aquarium Weight Calculator: water volume -> water weight + approx filled weight.
document.addEventListener('DOMContentLoaded', function () {
  var volEl = document.getElementById('tsWeightVolume');
  var unitEl = document.getElementById('tsWeightUnit');
  var subEl = document.getElementById('tsWeightSubstrate');
  var result = document.getElementById('tsWeightResult');

  if (!volEl || !unitEl || !result) {
    return;
  }

  function fmt(n) {
    return n.toLocaleString(undefined, { maximumFractionDigits: 1 });
  }

  function compute() {
    var vol = parseFloat(volEl.value);
    var substrate = parseFloat(subEl && subEl.value) || 0;

    if (!vol || vol <= 0) {
      result.innerHTML = '<p class="ts-widget__hint">Enter your water volume to estimate weight.</p>';
      return;
    }

    var gallons = unitEl.value === 'liters' ? vol / 3.78541 : vol;
    var waterLb = gallons * 8.34;
    var waterKg = waterLb * 0.453592;
    var filledLb = gallons * 10 + substrate; // water + typical tank/rock, plus any substrate entered
    var filledKg = filledLb * 0.453592;

    result.innerHTML =
      '<ul class="ts-widget__results">' +
      '<li><span>Water weight</span><strong>' + fmt(waterLb) + ' lb</strong></li>' +
      '<li><span>Water weight</span><strong>' + fmt(waterKg) + ' kg</strong></li>' +
      '<li><span>Approx. filled weight</span><strong>' + fmt(filledLb) + ' lb</strong></li>' +
      '<li><span>Approx. filled weight</span><strong>' + fmt(filledKg) + ' kg</strong></li>' +
      '</ul>' +
      '<p class="ts-widget__note">Water weighs 8.34 lb per gallon. Filled weight is approximate and includes water plus a typical tank and rock; add your substrate weight above for a closer estimate. Always confirm your floor and stand can carry the load.</p>';
  }

  volEl.addEventListener('input', compute);
  unitEl.addEventListener('change', compute);
  if (subEl) subEl.addEventListener('input', compute);
  compute();
});
